// Library imports
import React from 'react';
import { MDBTabs, MDBTabsItem, MDBTabsLink } from 'mdb-react-ui-kit';
import { array, bool, func, shape, string } from 'prop-types';
// Util imports
import { capitalize } from '../../utils/strings';

const TabNav = ({ tabs = [], activeTab = '', setTab, containerStyle = {}, buttonStyle = {}, textStyle = {}, disabled = false }) => {
    return (
        <MDBTabs style={{ ...containerStyle, flexWrap: 'nowrap' }}>
            {tabs.map((tab, i) => {
                const isActive = tab === activeTab;
                return (
                    <MDBTabsItem key={i} style={{ ...buttonStyle }}>
                        <MDBTabsLink
                            onClick={disabled ? undefined : () => setTab(tab)}
                            active={isActive}
                            style={{
                                background: isActive ? 'linear-gradient(#f0c876 0%, #b47806 100%)' : 'linear-gradient(135deg, #0f1117 0%, #1a1f2e 100%)',
                                border: `1px solid ${isActive ? 'rgba(180,120,6,0.7)' : 'rgba(255,255,255,0.1)'}`,
                                borderRadius: '999px',
                                color: isActive ? '#ffffff' : '#94a3b8',
                                fontWeight: 700,
                                letterSpacing: '0.04em',
                                textTransform: 'uppercase',
                                padding: '0.32rem 0.72rem',
                                marginRight: '0.35rem',
                                ...textStyle,
                                ...(disabled && {
                                    opacity: 0.8,
                                    cursor: 'not-allowed',
                                    pointerEvents: 'none',
                                }),
                            }}
                        >
                            {capitalize(tab)}
                        </MDBTabsLink>
                    </MDBTabsItem>
                );
            })}
        </MDBTabs>
    );
};

TabNav.propTypes = {
    tabs: array,
    activeTab: string,
    setTab: func.isRequired,
    buttonStyle: shape({}),
    containerStyle: shape({}),
    textStyle: shape({}),
    disabled: bool,
};

export default TabNav;
